import * as React from "react";
const SvgBakkappa = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 1" }, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.61 10.34a10.6 10.6 0 0 0-.53-2 10.4 10.4 0 0 0-2.31-3.74 10.7 10.7 0 1 0 1.07 13.5 10 10 0 0 0 1-1.75 10.7 10.7 0 0 0 .91-4.35 11.4 11.4 0 0 0-.14-1.66m-1.82-1.21L14.64 13l-2.56-1.18L19.76 7a9 9 0 0 1 1.03 2.13M10 10.74H8.1l9.38-6.12a7 7 0 0 1 1 .79Zm2 10.51a9.25 9.25 0 0 1 0-18.5 9.1 9.1 0 0 1 4.34 1.09L5.23 11.08l-.07.07a.2.2 0 0 0 0 .08.2.2 0 0 0 0 .08.4.4 0 0 0 0 .1v.05a.3.3 0 0 0 0 .1v.09a.6.6 0 0 0 .12.11.54.54 0 0 0 .22.24H9v6a1 1 0 0 0 .59.91L14.22 21a9 9 0 0 1-2.22.25m4.77-1.34L11 17.35v-3.79l8.45 3.9a9.2 9.2 0 0 1-2.68 2.45m0-5.87 4.41-2.81V12a9.3 9.3 0 0 1-.79 3.73Z",
	style: { fill: "currentColor" }
}))));
export default SvgBakkappa;
